import React from 'react'
import { useCollection } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import { Text } from '@morningtrain/react-columns'

function AggregateRatio ({ name, outOfName, display = Text, children, ...forwardProps }) {
  const collection = useCollection()

  const baseValue = collection.reduce((acc, entry) => {
    return acc + (entry[name] || 0)
  }, 0)

  const outOfValue = collection.reduce((acc, entry) => {
    return acc + (entry[outOfName] || 0)
  }, 0)

  const value = !outOfValue ? 0 : baseValue / outOfValue

  let DisplayComponent = display

  if (React.isValidElement(DisplayComponent)) {
    DisplayComponent = React.cloneElement(DisplayComponent, { defaultValue: value })
  } else if (DisplayComponent === null) {
    DisplayComponent = children
  } else {
    DisplayComponent = (
      <DisplayComponent defaultValue={value}>
        {children}
      </DisplayComponent>
    )
  }

  return DisplayComponent
}

export default observer(AggregateRatio)
